module.exports = __webpack_public_path__ + "img/tit3.c0dd8b35.png";